import React from 'react';
export default function CollectionHeader({title, description, actions}) {
 return <header className="module-heading collections-heading"><div className="panel-heading-copy"><div className="eyebrow">UXBI · COBRANZA</div><h1>{title}</h1><p>{description}</p></div><div className="panel-heading-actions">{actions}</div></header>;
}
